import { render, staticRenderFns } from "./r-world-region-territory-page.vue?vue&type=template&id=09f9892d"
import script from "./r-world-region-territory-page.vue?vue&type=script&lang=js"
export * from "./r-world-region-territory-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f9892d')) {
      api.createRecord('09f9892d', component.options)
    } else {
      api.reload('09f9892d', component.options)
    }
    module.hot.accept("./r-world-region-territory-page.vue?vue&type=template&id=09f9892d", function () {
      api.rerender('09f9892d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/world-region-territory/r-world-region-territory-page.vue"
export default component.exports